var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrivals = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.016 14.048a625 625 0 0 0-9.648-2.592L2.76 11V5.84l1.464.36.936 2.352 4.968 1.32V1.616l1.92.504 2.76 9 5.304 1.416q.6.168.912.72t.156 1.152-.684.888-1.128.144zm-11.52 4.536h19.032V20.6H2.496z"
})));
export default SvgArrivals;